import { START_EDIT, END_EDIT, TOGGLE_EDIT } from '@instructure/quiz-common';
export function startEdit(uniqueComponentKey) {
  var initialFocusId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return {
    type: START_EDIT,
    componentId: uniqueComponentKey,
    initialFocusId: initialFocusId
  };
}
export function endEdit(uniqueComponentKey) {
  return {
    type: END_EDIT,
    componentId: uniqueComponentKey
  };
}
export function toggleEditing(uniqueComponentKey) {
  return {
    type: TOGGLE_EDIT,
    componentId: uniqueComponentKey
  };
}